'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sift4distance = require('./sift4distance.js');

function mailCheck(email, config) {
    if (email === '') {
        return false;
    }
    return suggest(email, config);
}
function splitEmail(email) {
    var parts = email
        .trim()
        .split('@')
        .filter(function (part) { return part !== ''; });
    if (parts.length < 2) {
        return false;
    }
    var domain = parts.pop();
    var domainParts = domain.split('.');
    var firstPart = domainParts[0], tldParts = domainParts.slice(1);
    var secondLevelDomain = firstPart;
    var topLevelDomain = tldParts.join('.');
    return {
        topLevelDomain: secondLevelDomain,
        secondLevelDomain: topLevelDomain,
        domain: domain,
        address: parts.join('@'),
    };
}
function suggest(email, config) {
    var domains = config.domains, secondLevelDomains = config.secondLevelDomains, topLevelDomains = config.topLevelDomains, domainThreshold = config.domainThreshold, secondLevelThreshold = config.secondLevelThreshold, topLevelThreshold = config.topLevelThreshold;
    if (email === null) {
        return false;
    }
    var emailParts = splitEmail(email.toLowerCase());
    if (emailParts === false) {
        return false;
    }
    // If the email is a valid 2nd-level + top-level, do not suggest anything.
    if (secondLevelDomains.includes(emailParts.secondLevelDomain) &&
        topLevelDomains.includes(emailParts.topLevelDomain)) {
        return false;
    }
    var closestDomain = getClosestSuggestion(emailParts.domain, domains, domainThreshold);
    if (closestDomain) {
        if (closestDomain == emailParts.domain) {
            // The email address exactly matches one of the supplied domains; do not return a suggestion.
            return false;
        }
        // The email address closely matches one of the supplied domains; return a suggestion
        return {
            address: emailParts.address,
            domain: closestDomain,
            full: emailParts.address + '@' + closestDomain,
        };
    }
    // The email address does not closely match one of the supplied domains
    var closestSecondLevelDomain = getClosestSuggestion(emailParts.secondLevelDomain, secondLevelDomains, secondLevelThreshold);
    var closestTopLevelDomain = getClosestSuggestion(emailParts.topLevelDomain, topLevelDomains, topLevelThreshold);
    if (!emailParts.domain ||
        !closestSecondLevelDomain ||
        !closestTopLevelDomain) {
        return false;
    }
    closestDomain = getClosestDomain(emailParts, closestSecondLevelDomain, closestTopLevelDomain);
    return {
        address: emailParts.address,
        domain: closestDomain,
        full: emailParts.address + '@' + closestDomain,
    };
}
function getClosestDomain(email, closestSLD, closestTLD) {
    var closestDomain = email.domain;
    if (closestSLD !== email.secondLevelDomain) {
        // The email address may have a misspelled second-level domain; return a suggestion
        closestDomain = closestDomain.replace(email.secondLevelDomain, closestSLD);
    }
    if (closestTLD !== email.topLevelDomain && email.secondLevelDomain !== '') {
        // The email address may have a misspelled top-level domain; return a suggestion
        closestDomain = closestDomain.replace(new RegExp(email.topLevelDomain + '$'), closestTLD);
    }
    return closestDomain;
}
function getClosestSuggestion(domain, domains, threshold) {
    threshold = threshold;
    var dist;
    var minDist = Infinity;
    var closestDomain = '';
    if (!domain || !domains) {
        return false;
    }
    for (var _i = 0, domains_1 = domains; _i < domains_1.length; _i++) {
        var dom = domains_1[_i];
        if (domain === dom) {
            return domain;
        }
        dist = sift4distance.sift4Distance(domain, dom);
        if (dist < minDist) {
            minDist = dist;
            closestDomain = dom;
        }
    }
    if (minDist <= threshold && closestDomain !== '') {
        return closestDomain;
    }
    else {
        return false;
    }
}

exports.mailCheck = mailCheck;
